module.exports = __webpack_public_path__ + "static/media/trageberatung.92063426.jpg";